import { NewTypography as Typography } from '@lamimed/pantheon';
import Image from 'next/legacy/image';

import * as S from './styles';

import messageSentImage from '/public/images/illustration/get-in-touch/inviato.svg';

export const MessageSent = () => {
  return (
    <S.Wrapper>
      <Typography variant="heading_2" marginBottom="medium" textAlign="center">
        Messaggio inviato con successo
      </Typography>

      <S.ImageWrapper>
        <Image src={messageSentImage} quality={100} />
      </S.ImageWrapper>

      <Typography variant="body_text_2" textAlign="center" marginBottom="none">
        A breve entreremo in contatto
      </Typography>
    </S.Wrapper>
  );
};
